export default __webpack_public_path__ + "static/media/group.78539a18.jpg";